import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import _ from "lodash"
import Section from "components/layout/Section"

import BackEditDeleteButtons from "components/elements/Back_Edit_Delete_Buttons"
import ParasiteForm from "forms/Parasite_Form"
import {
  MODALS_SHOW,
  MODALS_CONFIRM_DELETE,
  PARASITES_DELETE,
} from "actions/types"

const INITIAL_STATE = {
  viewMode: true,
  valuesToEdit: {},
}

class ViewEntry extends Component {
  state = INITIAL_STATE

  UNSAFE_componentWillMount() {
    const { parasites, history, defaultRoute } = this.props
    const { id } = this.props.match.params
    const parasite = parasites.entries.filter(
      (parasite) => parasite._id === id
    )[0]
    if (!parasite) return history.push(`${defaultRoute}/view_entries`)
    this.setState({
      valuesToEdit: parasite,
    })
  }

  handleEditClick = () => {
    this.setState({
      viewMode: !this.state.viewMode,
    })
  }

  handleDeleteClick = () => {
    const successRoute = `${this.props.defaultRoute}/view_entries`
    this.props.dispatch({
      type: MODALS_SHOW,
      modalType: MODALS_CONFIRM_DELETE,
      modalProps: {
        type: "parasite",
        actionType: PARASITES_DELETE,
        history: this.props.history,
        successRoute: successRoute,
        item: this.state.valuesToEdit._id,
        providerView: this.props.providerView,
      },
    })
  }

  renderSectionContent() {
    if (_.isEmpty(this.state.valuesToEdit)) return <div />

    return (
      <>
        <BackEditDeleteButtons
          feature={this.props.name}
          handleEditClick={this.handleEditClick}
          handleDeleteClick={this.handleDeleteClick}
          viewMode={this.state.viewMode}
          providerView={this.props.providerView}
          providerEdit={this.props.providerEdit}
        />
        <div className="columns is-mobile is-centered">
          <div className="column is-5-desktop is-full-mobile is-6-tablet">
            <ParasiteForm
              editMode
              {...this.state}
              cancel={this.handleEditClick}
              {...this.props}
            />
          </div>
        </div>
      </>
    )
  }

  render() {
    return <Section>{this.renderSectionContent()}</Section>
  }
}

export default withRouter(ViewEntry)
